const compareDeviceGroups = (newGroups, oldGroups) => {
  const oldGroupsIds = oldGroups.map((group) => group.id);
  const newGroupsIds = newGroups.map((group) => group.id);

  const groupsToAdd = newGroups.filter(
    (group) => !oldGroupsIds.includes(group.id) && !group?.isNew
  );
  const groupsToRemove = oldGroups.filter((group) => !newGroupsIds.includes(group.id));
  const groupsToCreate = newGroups.filter((group) => group?.isNew);

  return { groupsToAdd, groupsToCreate, groupsToRemove };
};

const updateSelectedGroupOptions = (groupOptions, selectedGroups) => {
  const selectedGroupIds = selectedGroups?.map((group) => group.id);
  const groupOptionNames = groupOptions?.map((group) => group.value);
  const newGroupNames = selectedGroups
    ?.filter((group) => group?.isNew)
    ?.map((group) => group.value);

  const updatedGroups = [
    ...groupOptions?.filter(
      (group) => selectedGroupIds.includes(group.id) || newGroupNames.includes(group.value)
    ),
    ...selectedGroups?.filter((group) => group?.isNew && !groupOptionNames.includes(group?.value))
  ];

  return updatedGroups;
};

export const groupUtils = { compareDeviceGroups, updateSelectedGroupOptions };
